import { FC } from 'react';
import './styles.scss';

const Loader: FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`preloader dotted-preloader ${className}`}></div>
);

export default Loader;
